import React from 'react';
import PropTypes from 'prop-types';
import {
    WeezHeader,
    EmptyState,
    Table,
    TableBody,
    Card,
    TableRow,
    Icon,
    Numbers,
    TableHeaderCell,
    DropdownItem,
    Button,
    ButtonDropdown,
    TableCell,
    Status,
    ToastContext
} from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import { Loader } from 'semantic-ui-react';
import './taxes.scss';
import EventModel from '../../models/eventModel';
import { useHistory } from 'react-router-dom';
import AddCategoryTaxsModal from './addCategoryTaxsModal';
import AddTaxsModal from './addTaxsModal';
import RedditionTaxModel from '../../models/redditionTaxModel';
import Style from '../attendee/list/list.module.css';
import { InfoTextToolTipMemo } from '../attendee/list/components/attendee-row/attendee-row';
import i18n from 'i18next';
import RedditionTaxCategoryModel from '../../models/redditionTaxCategoryModel';
import TaxTreeModel from '../../models/taxeTreeModel';

export default function Taxs({ organization, event }) {
    const toast = React.useContext(ToastContext);
    const locale = i18n.language;
    const history = useHistory();

    const { t } = useTranslation();

    const [events, setEvents] = React.useState([]);
    const [groupeTaxeClosed, setGroupeTaxeClosed] = React.useState([]);
    const [taxTree, setTaxTree] = React.useState([]);
    const [eventIndex, setEventIndex] = React.useState(0);
    const [isLoadTree, setIsLoadTree] = React.useState(true);

    const [isLoadingEvents, setIsLoadingEvents] = React.useState(true);
    const [openAddCategoryTaxs, setOpenAddCategoryTaxs] = React.useState(false);
    const [openAddTaxs, setOpenAddTaxs] = React.useState(false);

    const [categoryTaxEdit, setCategoryTaxEdit] = React.useState();
    const [taxEdit, setTaxEdit] = React.useState();
    const [countTaxes, setCountTaxes] = React.useState(0);
    const [idTaxEyeLoad, setIdTaxEyeLoad] = React.useState();
    const [idTrashLoad, setIdTrashLoad] = React.useState();
    let [, ,] = TaxTreeModel.useApiModel({
        eventId: event.id,
        organizationId: organization.pk,
        onSuccess: data => {
            let obj = data.map(obj => obj.get('object'));
            setTaxTree(obj);
            let i = 0;
            obj.forEach(element => {
                i += element.tax_specific.filter(obj => obj.delete !== '1').length;
            });
            setCountTaxes(i);
            setIsLoadTree(false);
        }
    });

    let fetchEvents = React.useCallback(() => {
        EventModel.getAll({ organizationId: organization.id })
            .then(response => {
                setEvents(events ? events.concat(response) : response);
                setEventIndex(response.findIndex(e => e.id === event.id));
                setIsLoadingEvents(false);
            })
            .catch(e => {
                Sentry.captureException(e);
                toast.error(t('ticket.event.list.error'));
            });
    });
    React.useEffect(() => {
        if (isLoadingEvents) {
            fetchEvents();
        }
    }, [isLoadingEvents]);

    const label = [
        { label: t('ticket.tax.label.Taxs'), name: 'taxs', align: 'left' },
        { label: t('ticket.tax.label.Plates'), name: 'assiettes', align: 'left' },
        { label: t('ticket.tax.label.Rate'), name: 'taux', align: 'left' },
        { label: t('ticket.tax.label.visibility'), name: 'visibility', align: 'center' }
    ];

    const saveEditCategorie = (e, id_category) => {
        let ret = taxTree.map(category => {
            if (category.id_category === id_category) {
                return { ...e.response, tax_specific: category.tax_specific };
            } else {
                return category;
            }
        });
        setTaxTree(ret);
    };

    const saveCategorieInTree = e => {
        let ret = taxTree;
        e.tax_specific = [];
        ret.push(e);
        setTaxTree(ret);
    };
    const saveTaxeInTree = e => {
        let ret = taxTree;
        ret = ret.map(obj => {
            if (obj.id_category === e.id_category) {
                setCountTaxes(countTaxes + 1);
                obj.tax_specific.push(e);
                return obj;
            } else {
                return obj;
            }
        });
        setTaxTree(ret);
    };

    const saveEditTax = (e, id_category, id_tax) => {
        let ret = taxTree.map(category => {
            if (category.id_category === id_category) {
                category.tax_specific = category.tax_specific.map(tax => {
                    if (tax.id_tax === id_tax) {
                        if (e.response.delete === '1') {
                            setCountTaxes(countTaxes - 1);
                        }
                        return e.response;
                    } else {
                        return tax;
                    }
                });
                return category;
            } else {
                return category;
            }
        });
        setTaxTree(ret);
    };

    let getColor = str => {
        switch (str) {
            case 'published':
                return 'green';
            case 'draft':
                return 'orange';
            case 'finished':
                return undefined;
            case 'closed':
                return 'red';

            default:
                break;
        }
    };

    const onEditCategorieTax = React.useCallback(
        value => {
            return new RedditionTaxCategoryModel(value).save({
                organizationId: organization.pk,
                eventId: event.id
            });
        },
        [isLoadTree]
    );

    const onEditTax = React.useCallback(
        value => {
            return new RedditionTaxModel(value).save({
                eventId: event.id,
                organizationId: organization.pk
            });
        },
        [isLoadTree, event, organization]
    );

    if (isLoadTree || isLoadingEvents) {
        return <Loader active inline="centered" />;
    }

    return (
        <>
            {openAddCategoryTaxs && (
                <AddCategoryTaxsModal
                    saveEditCategorie={saveEditCategorie}
                    saveCategorieInTree={saveCategorieInTree}
                    taxCategoryId={taxTree.length}
                    eventId={event.id}
                    onEditCategorieTax={onEditCategorieTax}
                    openModal={openAddCategoryTaxs}
                    onClose={() => {
                        setOpenAddCategoryTaxs(false);
                        setCategoryTaxEdit();
                    }}
                    categoryTaxEdit={categoryTaxEdit}
                ></AddCategoryTaxsModal>
            )}
            {openAddTaxs && (
                <AddTaxsModal
                    saveTaxeInTree={saveTaxeInTree}
                    saveEditTaxe={saveEditTax}
                    onEditTax={onEditTax}
                    currancy={event?.currency}
                    taxEdit={taxEdit}
                    taxTree={taxTree.filter(obj => obj.delete !== '1')}
                    eventId={event.id}
                    openModal={openAddTaxs}
                    onClose={() => {
                        setOpenAddTaxs(false);
                        setTaxEdit();
                    }}
                ></AddTaxsModal>
            )}
            <WeezHeader
                title={
                    <div style={{ display: 'flex' }}>
                        {<div>{`${t('ticket.tax.title')} : ${events[eventIndex]?.name}`}</div>}
                        <Status
                            style={{ margin: '0 15px', display: 'flex', 'align-items': 'center' }}
                            text={events[eventIndex]?.status}
                            color={getColor(events[eventIndex]?.status)}
                        ></Status>
                    </div>
                }
                backLink={{
                    onClick: () => history.push(`/ticket/O${organization.id}/organization/accounting`)
                }}
                rightComponent={
                    <div style={{ display: 'flex', margin: 'auto 15px' }}>
                        <div style={{ margin: 'auto 15px' }}>
                            <Icon
                                name={'chevron-left'}
                                margin={false}
                                onClick={() => {
                                    if (eventIndex > 0) {
                                        history.push(`/ticket/O${organization.id}/E${events[eventIndex - 1].id}/taxes`);
                                    }
                                }}
                            />
                            <span>{`${eventIndex + 1}/${events.length}`}</span>
                            <Icon
                                name={'chevron-right'}
                                margin={false}
                                onClick={() => {
                                    if (eventIndex + 1 < events.length) {
                                        history.push(`/ticket/O${organization.id}/E${events[eventIndex + 1].id}/taxes`);
                                    }
                                }}
                            />
                        </div>
                        <ButtonDropdown
                            items={[
                                <DropdownItem key="toto" item={t('ticket.tax.tax')} onClick={() => setOpenAddTaxs(true)} />,
                                <DropdownItem key="tata" item={t('ticket.tax.category')} onClick={() => setOpenAddCategoryTaxs(true)} />
                            ]}
                            trigger={
                                <Button
                                    color="ticket"
                                    icon={<Icon name={'plus'} margin={false} />}
                                    disabled={false}
                                    fluid={false}
                                    isLoading={false}
                                    label={t('ticket.common.action.add')}
                                />
                            }
                        />
                    </div>
                }
            >
                {t('ticket.tax.sub')}
            </WeezHeader>{' '}
            <Card className="NoMargin">
                <div style={{ padding: '15px', 'text-align': 'right' }}>
                    <div style={{ 'font-size': '24px', color: 'rgb(0, 50, 250)' }}>
                        <span style={{ 'font-weight': 'bold' }}>{countTaxes} </span>
                        <span>{countTaxes > 1 ? t('ticket.tax.tax_plural') : t('ticket.tax.tax')}</span>
                    </div>
                </div>
                <Table className={(Style['list__table'], 'taxTable')}>
                    <Table.THead>
                        <Table.Tr isHeader>
                            {label.map((obj, key) => (
                                <TableHeaderCell className={obj.align === 'center' ? 'center' : ''} key={key}>
                                    {obj.label}
                                </TableHeaderCell>
                            ))}

                            <TableHeaderCell className="center" style={{ width: '100px' }}>
                                {t('ticket.accounting.filter.actionLabel')}
                            </TableHeaderCell>
                        </Table.Tr>
                    </Table.THead>
                    {!isLoadingEvents && !isLoadTree && taxTree && taxTree.filter(obj => obj.delete !== '1').length > 0 && (
                        <TableBody>
                            {taxTree
                                ?.filter(obj => obj.delete !== '1')
                                .map((value, key) => (
                                    <>
                                        <TableRow
                                            key={key}
                                            className="groupe"
                                            onClick={() => {
                                                let groupeTaxeClosedCpy = [...groupeTaxeClosed];
                                                if (groupeTaxeClosed.includes(value.id_category)) {
                                                    groupeTaxeClosedCpy = groupeTaxeClosedCpy.filter(e => e !== value.id_category);
                                                } else {
                                                    groupeTaxeClosedCpy.push(value.id_category);
                                                }
                                                setGroupeTaxeClosed(groupeTaxeClosedCpy);
                                            }}
                                        >
                                            <TableCell>
                                                <div style={{ display: 'flex' }}>
                                                    <Icon name={'folder-open'} />
                                                    <InfoTextToolTipMemo title={value.name} />
                                                </div>
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell className="center">
                                                {idTaxEyeLoad === value.id_category ? (
                                                    <Loader size="mini" active inline="centered" />
                                                ) : (
                                                    <Icon
                                                        name={value.visibility === '1' ? 'eye' : 'eye-slash'}
                                                        onClick={() => {
                                                            setIdTaxEyeLoad(value.id_category);

                                                            onEditCategorieTax({
                                                                id_evenement: event.id,
                                                                id_category: value.id_category,
                                                                visibility: value.visibility === '1' ? '0' : '1'
                                                            }).then(e => {
                                                                toast.success(t('ticket.accounting.saveModif'));
                                                                saveEditCategorie(e, value.id_category);
                                                                setIdTaxEyeLoad();
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell className="center">
                                                <Icon
                                                    name={'edit'}
                                                    onClick={() => {
                                                        setCategoryTaxEdit(value);
                                                        setOpenAddCategoryTaxs(true);
                                                    }}
                                                />
                                                {idTrashLoad === value.id_category ? (
                                                    <Loader size="mini" style={{ padding: '5px 15px' }} active inline />
                                                ) : (
                                                    <Icon
                                                        name={'trash'}
                                                        onClick={() => {
                                                            setIdTrashLoad(value.id_category);
                                                            onEditCategorieTax({ id_evenement: event.id, id_category: value.id_category, delete: '1' }).then(e => {
                                                                saveEditCategorie(e, value.id_category);
                                                                setIdTrashLoad();
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                        </TableRow>
                                        {value.tax_specific
                                            .filter(obj => obj.delete !== '1' && !groupeTaxeClosed.includes(obj.id_category))
                                            .map((_value, key) => (
                                                <TableRow
                                                    key={key}
                                                    onClick={() => {
                                                        // setTaxEdit(_value);
                                                        // setOpenAddTaxs(true);
                                                    }}
                                                >
                                                    <TableCell>
                                                        <InfoTextToolTipMemo title={_value.label} />
                                                    </TableCell>

                                                    <TableCell>
                                                        <InfoTextToolTipMemo title={_value.base === '1' ? t('ticket.tax.revenueExcludingVAT') : t('ticket.tax.payingAttendees')} />
                                                    </TableCell>
                                                    <TableCell>
                                                        {_value.type_value === '1' ? (
                                                            <Numbers
                                                                showNullDecimal={true}
                                                                value={parseInt(_value.value, 10).toFixed(2) || 0}
                                                                locale={locale}
                                                                currency={event?.currency}
                                                            />
                                                        ) : (
                                                            <span>{parseInt(_value.value, 10).toFixed(2) + '%'}</span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell className="center">
                                                        {idTaxEyeLoad === _value.id_tax ? (
                                                            <Loader active size="mini" inline="centered" />
                                                        ) : (
                                                            <Icon
                                                                name={_value.visibility === '1' ? 'eye' : 'eye-slash'}
                                                                onClick={() => {
                                                                    setIdTaxEyeLoad(_value.id_tax);
                                                                    onEditTax({
                                                                        id_evenement: event.id,
                                                                        id_tax: _value.id_tax,
                                                                        id_category: value.id_category,
                                                                        visibility: _value.visibility === '1' ? '0' : '1'
                                                                    }).then(e => {
                                                                        toast.success(t('ticket.accounting.saveModif'));
                                                                        saveEditTax(e, value.id_category, _value.id_tax);
                                                                        setIdTaxEyeLoad();
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                    <TableCell className="center">
                                                        <Icon
                                                            name={'edit'}
                                                            onClick={() => {
                                                                setTaxEdit(_value);
                                                                setOpenAddTaxs(true);
                                                            }}
                                                        />
                                                        {idTrashLoad === _value.id_tax ? (
                                                            <Loader style={{ padding: '5px 15px' }} size="mini" active inline />
                                                        ) : (
                                                            <Icon
                                                                name={'trash'}
                                                                onClick={() => {
                                                                    setIdTrashLoad(_value.id_tax);
                                                                    onEditTax({
                                                                        id_evenement: event.id,
                                                                        id_tax: _value.id_tax,
                                                                        delete: '1'
                                                                    }).then(e => {
                                                                        saveEditTax(e, value.id_category, _value.id_tax);
                                                                        setIdTrashLoad();
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </>
                                ))}
                        </TableBody>
                    )}
                </Table>
                {!isLoadingEvents && !isLoadTree && taxTree.filter(obj => obj.delete !== '1').length === 0 && (
                    <EmptyState
                        icon={<Icon name="list" />}
                        title={t('ticket.tax.noTaxe')}
                        labelButton={t('ticket.tax.addTaxCategory')}
                        onClick={() => setOpenAddCategoryTaxs(true)}
                    />
                )}
            </Card>
        </>
    );
}

Taxs.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired
};
